export default __webpack_public_path__ + "static/media/Sketch.de27cbc3.svg";